export enum CompanyPlugin {
    WorkloadManager,
    AiImporter
}